// @flow

import { graphql } from 'react-relay';
import { ConnectionHandler } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation DeleteVendorMutation($input: DeleteVendorInput!) {
    deleteVendor(input: $input) {
      success
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      updater: (store) => {
        const deletedVendorId = options.variables.input.id;
        
        // Remove the vendor from the vendors connection
        const root = store.getRoot();
        const connection = ConnectionHandler.getConnection(
          root,
          'VendorList_vendors'
        );
        
        if (connection && deletedVendorId) {
          ConnectionHandler.deleteNode(connection, deletedVendorId);
        }
      },
    });
  },
};
